import React from 'react'

import { useBlockedUserToast } from '../../../lib/auth/hooks/useBlockedUserToast'
import { usePatientBrowseDispensaryToast } from '../../../lib/dispensaries/hooks/usePatientBrowseDispensaryToast'
import { useOnboardingToast } from '../../../lib/onboarding/hooks/useOnboardingToast'
import { useUserPrivacyQualifiers } from '../../../lib/privacy/hooks/useUserPrivacyQualifiers'
import { SessionExpirationModal } from '../../auth/SessionExpirationModal'
import { HideAllToasts } from '../../HideAllToasts'
import { SubmitPractitionerFormsReminder } from '../../onboarding/practitioner/SubmitPractitionerFormsReminder'
import { QuickViewProductModal } from '../../products/QuickViewProductModal'
import { SupportTicketModal } from '../../support/SupportTicketModal'
import { Footer } from '../footer'
import { Header } from '../header'
import * as Styled from './styled'

const Toasts: React.FC = () => {
  useOnboardingToast()
  usePatientBrowseDispensaryToast()
  useBlockedUserToast()

  return <SubmitPractitionerFormsReminder />
}

export interface LayoutProps {
  children?: React.ReactNode
  className?: string
  fullWidth?: boolean
  increasedWidth?: boolean
  noToasts?: boolean
  showAccountMenu?: boolean
  showFooter?: boolean
  showHeader?: boolean
}

const Layout: React.FC<LayoutProps> = ({
  children,
  className = '',
  fullWidth = false,
  increasedWidth = false,
  noToasts = false,
  showAccountMenu = false,
  showFooter = true,
  showHeader = true,
}) => {
  useUserPrivacyQualifiers()

  return (
    <Styled.Container
      $enableHeaderPadding={showHeader}
      $fillHeight={!showFooter}
      $fullWidth={fullWidth}
      data-cy="layout-root"
    >
      <Styled.SkipNavigationLink href="#mainContent">Skip navigation</Styled.SkipNavigationLink>
      {showHeader && (
        <>
          <Styled.HeaderSpacer />
          <Header showAccountMenu={showAccountMenu} />
        </>
      )}
      <Styled.PageContainer
        className={className}
        $fillHeight={!showFooter}
        $fullWidth={fullWidth}
        $useIncreasedWidth={increasedWidth}
        data-cy="page-container"
      >
        {children}
      </Styled.PageContainer>
      {showFooter && <Footer />}
      {noToasts ? <HideAllToasts /> : <Toasts />}
      <SessionExpirationModal />
      <QuickViewProductModal />
      <SupportTicketModal />
    </Styled.Container>
  )
}

export default Layout
